import { History } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { errText, frDateTime } from "@/components/prospect/common";

export function NocrmHistoryImport() {
  const [st, setSt] = useState(null);
  const load = useCallback(() => api.get("/prospect/nocrm-history/status").then(({ data }) => setSt(data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { if (st?.status !== "running") return undefined; const t = setInterval(load, 5000); return () => clearInterval(t); }, [st?.status, load]);
  const start = async () => { try { setSt((await api.post("/prospect/nocrm-history/import")).data); toast.success("Import de l'historique noCRM lancé."); } catch (e) { toast.error(errText(e)); } };
  const running = st?.status === "running";
  return (
    <section className="ps-card ps-nocrm-import" data-testid="nocrm-history-import">
      <h3><span><History size={14} /> Historique des listes de prospection noCRM</span></h3>
      <p className="pl-muted">Récupère les commentaires, appels et statuts de vos listes noCRM et les rattache aux contacts des fichiers en cours ayant le même numéro de téléphone. Rien n'est écrasé dans vos fichiers.</p>
      {st?.sheets_total > 0 && (
        <div className="ps-nocrm-progress" data-testid="nocrm-history-progress">
          <div><span style={{ width: `${Math.round((100 * (st.sheets_done || 0)) / st.sheets_total)}%` }} /></div>
          <small>{st.sheets_done || 0} / {st.sheets_total} listes analysées · {(st.rows_matched || 0).toLocaleString("fr-FR")} contacts retrouvés{st.status === "done" && st.finished_at ? ` · terminé le ${frDateTime(st.finished_at)}` : ""}</small>
        </div>
      )}
      {st?.waiting_until && <p className="ps-se-warn" data-testid="nocrm-history-waiting">En pause jusqu'au {frDateTime(st.waiting_until)} : {st.waiting_reason}.</p>}
      {st?.sheets_total > 0 && <small className="pl-muted">Requêtes noCRM utilisées aujourd'hui par l'import : {st.calls_today || 0} / {st.daily_budget}</small>}
      {st?.status === "error" && <p className="ps-se-warn">Import interrompu : {st.error}</p>}
      <button type="button" className="primary-button" disabled={running} onClick={start} data-testid="nocrm-history-start">{running ? "Import en cours…" : st?.status === "paused" ? "Reprendre l'import" : st?.status === "done" ? "Mettre à jour l'historique" : "Importer l'historique noCRM"}</button>
    </section>
  );
}
